import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  AllOrganizationalUnitsFilter,
  Identifiable,
  OrganizationalUnit,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  organizationalUnits: Identifiable<OrganizationalUnit>[];
  filter: AllOrganizationalUnitsFilter;
  totalPages: number;
  retrieveAllOrganizationalUnits(
    request: Boundaries["retrieveAllOrganizationalUnits"]["request"],
  ): void;
}

function useRetrieveAllOrganizationalUnits(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveAllOrganizationalUnitsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveAllOrganizationalUnitsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveAllOrganizationalUnitsRequestFailure,
    ),
    organizationalUnits: useSelector(selector.getAllOrganizationalUnits),
    filter: useSelector(selector.getAllOrganizationalUnitsFilter),
    totalPages: useSelector(selector.getAllOrganizationalUnitsTotalPages),
    retrieveAllOrganizationalUnits: core.retrieveAllOrganizationalUnits,
  };
}

export { useRetrieveAllOrganizationalUnits };
